import { Paging } from "../../paging/paging"
import { TieupRankingGetInputModel } from "../../../api/v1/tieup/ranking/GetInputModel"
import { callGetTieupRanking } from "../../../api/v1/tieup/ranking/get"
import { WorkItem } from "../../WorkItem/WorkItem"

export const fetchTieupRanking = async (
  category: "total" | "monthly",
  showR18: boolean,
  limit: number,
  offset: number,
): Promise<Paging<WorkItem>> => {
  const model = new TieupRankingGetInputModel({
    category,
    showR18,
    limit,
    offset,
  })

  return callGetTieupRanking(model).then((v) => {
    return {
      total: v.count,
      items: v.results,
    }
  })
}
